import { trackEvent, trackPurchaseClick } from "../utils/Analytics";
import { PrimaryButton } from "./Buttons";

function OrderButton({ href, disabled, children, isLarge = false, className = "", user, analyticsSurface = "web_landing", analyticsPlacement = "order_button" }) {
    const defaultHref = "https://buy.stripe.com/8x2bJ17g71w40Ut4aifQI05";

    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        trackEvent('Order', 'Order Clicked', 'User clicked order button', undefined, {
        });
        trackPurchaseClick({
            surface: analyticsSurface,
            placement: analyticsPlacement,
        });
    };

    return (
        <PrimaryButton
            href={href || defaultHref}
            className={className}
            icon="order"
            isLarge={isLarge}
            disabled={disabled}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
        >
            {children || "Order Your Deck"}
        </PrimaryButton>
    );
}

export default OrderButton;
